// Domain
import { CustomerBankAccountRepository } from '../../../domain/repositories/customer-bank-account-repository';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class CustomerBankAccountDummyRepository implements CustomerBankAccountRepository {
  update(): Promise<void> {
    return Promise.resolve();
  }
}
